import { useEffect } from 'react';
import { Capacitor } from '@capacitor/core';

const cleanupServiceWorkers = async () => {
  if ('serviceWorker' in navigator) {
    const registrations = await navigator.serviceWorker.getRegistrations();
    await Promise.all(registrations.map((registration) => registration.unregister()));
  }

  if ('caches' in window) {
    const keys = await caches.keys();
    await Promise.all(keys.map((key) => caches.delete(key)));
  }
};

export const PWAUpdatePrompt = () => {
  useEffect(() => {
    if (!Capacitor.isNativePlatform()) return;

    const nativeCleanKey = '__native_sw_cleaned_v3';
    if (!localStorage.getItem(nativeCleanKey)) {
      cleanupServiceWorkers()
        .catch(() => undefined)
        .finally(() => {
          localStorage.setItem(nativeCleanKey, 'true');
        });
    }
  }, []);

  return null;
};
